import { ReactNode } from "react";

interface ContainerProps {
  children: ReactNode;
  className?: string;
  variant?: "default" | "wide" | "narrow";
}

export default function Container({ 
  children, 
  className = "", 
  variant = "default" 
}: ContainerProps) {
  const widthClasses = {
    default: "w-[90%] max-w-[1200px]",
    wide: "w-[95%] max-w-[1400px]",
    narrow: "w-[85%] max-w-[800px]",
  };

  return (
    <div className={`${widthClasses[variant]} mx-auto ${className}`}>
      {children}
    </div>
  );
}